import { employeeFieldSetDTOSchema, employeeImportReportSchema, personDTOSchema, personSmsOptOutDTOSchema, } from '@instanexus/contracts';
import { z } from 'zod';
import { dataEnvelopeSchema, listEnvelopeSchema, WEB_API_PREFIX, } from '../transport.js';
const listPeopleSchema = listEnvelopeSchema(personDTOSchema);
const singlePersonSchema = dataEnvelopeSchema(personDTOSchema);
const employeeImportReportEnvelopeSchema = dataEnvelopeSchema(employeeImportReportSchema);
const smsOptOutEnvelopeSchema = dataEnvelopeSchema(personSmsOptOutDTOSchema);
export function createPeopleResource(transport) {
    return {
        async list(params = {}) {
            return transport.request({
                path: `${WEB_API_PREFIX}/people`,
                schema: listPeopleSchema,
                query: {
                    page: params.page,
                    pageSize: params.pageSize,
                    sort: params.sort,
                    departmentId: params.departmentId,
                    personType: params.personType,
                    q: params.q,
                    locationId: params.locationId,
                    source: params.source,
                },
            });
        },
        async create(input) {
            const envelope = await transport.request({
                method: 'POST',
                path: `${WEB_API_PREFIX}/people`,
                schema: singlePersonSchema,
                body: input,
            });
            return envelope.data;
        },
        async update(id, input) {
            const envelope = await transport.request({
                method: 'PATCH',
                path: `${WEB_API_PREFIX}/people/${encodeURIComponent(id)}`,
                schema: singlePersonSchema,
                body: input,
            });
            return envelope.data;
        },
        async remove(id) {
            await transport.request({
                method: 'DELETE',
                path: `${WEB_API_PREFIX}/people/${encodeURIComponent(id)}`,
                schema: z.undefined(),
            });
        },
        async smsOptOut(id) {
            const envelope = await transport.request({
                path: `${WEB_API_PREFIX}/people/${encodeURIComponent(id)}/sms-opt-out`,
                schema: smsOptOutEnvelopeSchema,
            });
            return envelope.data;
        },
        async setSmsOptOut(id, input) {
            const envelope = await transport.request({
                method: 'PUT',
                path: `${WEB_API_PREFIX}/people/${encodeURIComponent(id)}/sms-opt-out`,
                schema: smsOptOutEnvelopeSchema,
                body: input,
            });
            return envelope.data;
        },
        async fieldSet() {
            const envelope = await transport.request({
                path: `${WEB_API_PREFIX}/people/field-set`,
                schema: dataEnvelopeSchema(employeeFieldSetDTOSchema),
            });
            return envelope.data;
        },
        async importTemplate() {
            return transport.requestText({ path: `${WEB_API_PREFIX}/people/import/template`, accept: 'text/csv' });
        },
        async importPreview(file, contentType, locationId) {
            const envelope = await transport.requestUpload({
                path: `${WEB_API_PREFIX}/people/import/preview`,
                schema: employeeImportReportEnvelopeSchema,
                contentType,
                body: file,
                query: locationId === undefined ? undefined : { locationId },
            });
            return envelope.data;
        },
        async importCommit(file, contentType, locationId) {
            const envelope = await transport.requestUpload({
                path: `${WEB_API_PREFIX}/people/import/commit`,
                schema: employeeImportReportEnvelopeSchema,
                contentType,
                body: file,
                query: locationId === undefined ? undefined : { locationId },
            });
            return envelope.data;
        },
    };
}
//# sourceMappingURL=people.js.map